const napiGet = async (path: string, idToken: string) => {
    const output = await fetch(`${process.env.REACT_APP_NAPI_URL}/${path}`, {
        headers: {
            'x-fb-token': idToken,
        },
    });
    return output;
};

export const getUserByEmail = async (email: string, idToken: string) => {
    const output = await napiGet(`users/search?email=${email}`, idToken);
    return await output.json();
};

export const getUser = async (id: string, idToken: string) => {
    const output = await napiGet(`users/${id}`, idToken);
    return await output.json();
};

export const getSupplier = async (id: string, idToken: string) => {
    const output = await napiGet(`suppliers/${id}`, idToken);
    return await output.json();
};
